import useSettings from '../../hooks/Settings'

// Dashboard colour picker used by DashboardCardOptions for both the primary
// colour mode and the per-sub-item palette rows. Renders the house-style
// swatches plus a free-form <input type="color"> so users can pick anything.
// Calls onChange(hex) with the chosen hex string.
const DashboardColorPicker = ({ value, onChange }) => {
    const { PrimaryColor, SecundairyColor, TertairyColor } = useSettings()

    const housestyle = [
        { id: 'primary', color: PrimaryColor, label: 'Primair' },
        { id: 'secundairy', color: SecundairyColor, label: 'Secundair' },
        { id: 'tertiary', color: TertairyColor, label: 'Tertiair' },
    ].filter(s => s.color)

    return (
        <div className='dashboard-color-picker'>
            <div className='dashboard-color-picker-swatches'>
                {housestyle.map(({ id, color, label }) => {
                    const selected = value === color
                    return (
                        <button
                            key={id}
                            type='button'
                            className={`dashboard-color-picker-swatch${selected ? ' dashboard-color-picker-swatch--selected' : ''}`}
                            style={{ backgroundColor: color }}
                            onClick={() => onChange(color)}
                            aria-label={label}
                        />
                    )
                })}
            </div>
            <label className='dashboard-color-picker-custom'>
                <span>Aangepast</span>
                <input
                    type='color'
                    value={value || PrimaryColor || '#000000'}
                    onChange={(e) => onChange(e.target.value)}
                />
            </label>
        </div>
    )
}

export default DashboardColorPicker
